export const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=JetBrains+Mono:wght@400;500;600&display=swap');

  :root {
    --bg-deep: #060F1F;
    --bg-primary: #0B1E3A;
    --bg-card: #0F2847;
    --bg-card-hover: #133054;
    --bg-elevated: #163660;
    --bg-input: #091A33;
    --border: #1C3D6B;
    --border-focus: #3B8BF5;
    --text-primary: #E4EBF5;
    --text-secondary: #8DA4C4;
    --text-muted: #4D6A8F;
    --accent: #3B8BF5;
    --accent-glow: rgba(59, 139, 245, 0.3);
    --accent-soft: rgba(59, 139, 245, 0.14);
    --highlight: #DB0000;
    --highlight-glow: rgba(219, 0, 0, 0.3);
    --highlight-soft: rgba(219, 0, 0, 0.14);
    --green: #22c55e;
    --green-soft: rgba(34, 197, 94, 0.14);
    --red: #DB0000;
    --red-soft: rgba(219, 0, 0, 0.14);
    --amber: #f59e0b;
    --amber-soft: rgba(245, 158, 11, 0.14);
    --pokemon-gold: #FFD700;
    --onepiece-red: #DB0000;
    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-xl: 20px;
    --shadow-card: 0 2px 16px rgba(4,10,24,0.5);
    --shadow-glow: 0 0 30px rgba(59, 139, 245, 0.18);
  }

  * { margin: 0; padding: 0; box-sizing: border-box; }
  body, html, #root { font-family: 'Outfit', sans-serif; background: var(--bg-deep); color: var(--text-primary); min-height: 100vh; -webkit-font-smoothing: antialiased; }

  @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes slideIn { from { opacity: 0; transform: translateX(-20px); } to { opacity: 1; transform: translateX(0); } }
  @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  @keyframes pulse { 0%, 100% { opacity: 0.4; } 50% { opacity: 0.8; } }

  .app-container { min-height: 100vh; display: flex; flex-direction: column; }
  .app-layout { display: flex; min-height: 100vh; }

  /* ── Sidebar ── */
  .sidebar { width: 240px; min-width: 240px; background: rgba(8,22,46,0.95); backdrop-filter: blur(20px); border-right: 1px solid var(--border); display: flex; flex-direction: column; position: fixed; top: 0; left: 0; bottom: 0; z-index: 100; overflow-y: auto; }
  .sidebar-brand { display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 20px; letter-spacing: -0.5px; cursor: pointer; padding: 28px 16px 24px; border-bottom: 1px solid var(--border); }
  .sidebar-brand span { background: linear-gradient(135deg, #DB0000, #FF4444); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .sidebar-brand img { height: 56px; width: auto; object-fit: contain; }
  .nav-brand img { height: 32px; width: auto; object-fit: contain; }
  .sidebar-nav { flex: 1; padding: 16px 12px; display: flex; flex-direction: column; gap: 4px; }
  .sidebar-section { font-size: 11px; color: var(--text-muted); text-transform: uppercase; letter-spacing: 1.2px; font-weight: 700; padding: 16px 12px 6px; }
  .sidebar-link { padding: 10px 14px; border-radius: var(--radius-sm); font-size: 14px; font-weight: 500; color: var(--text-secondary); cursor: pointer; display: flex; align-items: center; gap: 10px; transition: all 0.2s; border: none; background: none; width: 100%; text-align: left; font-family: 'Outfit', sans-serif; }
  .sidebar-link:hover { color: var(--text-primary); background: var(--bg-elevated); }
  .sidebar-link.active { color: var(--accent); background: var(--accent-soft); }
  .sidebar-footer { padding: 16px; border-top: 1px solid var(--border); display: flex; flex-direction: column; gap: 10px; }
  .sidebar-user { display: flex; align-items: center; gap: 10px; padding: 4px 0; }
  .sidebar-avatar { width: 32px; height: 32px; border-radius: 50%; background: var(--accent-soft); display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 13px; color: var(--accent); flex-shrink: 0; overflow: hidden; }
  .sidebar-avatar img { width: 100%; height: 100%; object-fit: cover; }
  .sidebar-username { font-size: 13px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .sidebar-email { font-size: 11px; color: var(--text-muted); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .nav-brand { display: flex; align-items: center; gap: 10px; font-weight: 800; font-size: 20px; letter-spacing: -0.5px; cursor: pointer; }
  .nav-brand span { background: linear-gradient(135deg, #DB0000, #FF4444); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .nav-logout { padding: 6px 12px; border-radius: var(--radius-sm); font-size: 13px; color: var(--text-muted); cursor: pointer; border: 1px solid var(--border); background: none; transition: all 0.2s; display: flex; align-items: center; gap: 6px; width: 100%; justify-content: center; font-family: 'Outfit', sans-serif; }
  .nav-logout:hover { color: var(--red); border-color: var(--red); }

  .content { flex: 1; margin-left: 240px; padding: 32px 32px; min-height: 100vh; max-width: 1200px; }
  .page-header { margin-bottom: 28px; animation: fadeIn 0.4s ease; }
  .page-title { font-size: 28px; font-weight: 800; letter-spacing: -0.5px; }
  .page-subtitle { font-size: 14px; color: var(--text-secondary); margin-top: 4px; }

  .card { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 24px; transition: all 0.25s; }
  .card:hover { border-color: rgba(59,139,245,0.2); }
  .card-label { font-size: 12px; color: var(--text-muted); text-transform: uppercase; letter-spacing: 1px; font-weight: 600; margin-bottom: 8px; }
  .card-value { font-size: 28px; font-weight: 800; letter-spacing: -1px; font-family: 'JetBrains Mono', monospace; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .card-sub { font-size: 13px; margin-top: 6px; display: flex; align-items: center; gap: 4px; font-weight: 500; }
  .metrics-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; margin-bottom: 28px; }

  .btn { padding: 10px 20px; border-radius: var(--radius-sm); font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; border: none; display: inline-flex; align-items: center; gap: 8px; font-family: 'Outfit', sans-serif; }
  .btn-primary { background: var(--accent); color: white; }
  .btn-primary:hover { background: #2B7AE4; box-shadow: var(--shadow-glow); }
  .btn-highlight { background: var(--highlight); color: white; }
  .btn-highlight:hover { background: #C40000; box-shadow: 0 0 30px rgba(219,0,0,0.25); }
  .btn-secondary { background: var(--bg-elevated); color: var(--text-primary); border: 1px solid var(--border); }
  .btn-secondary:hover { border-color: var(--accent); }
  .btn-danger { background: var(--red-soft); color: var(--red); }
  .btn-danger:hover { background: rgba(219,0,0,0.2); }
  .btn-ghost { background: none; color: var(--text-secondary); }
  .btn-ghost:hover { color: var(--text-primary); }
  .btn-sm { padding: 6px 12px; font-size: 13px; }
  .btn-lg { padding: 14px 32px; font-size: 16px; border-radius: var(--radius-md); }
  .btn-full { width: 100%; justify-content: center; }
  .btn-google { background: white; color: #333; border: 1px solid #ddd; }
  .btn-google:hover { background: #f8f8f8; }
  .btn:disabled { opacity: 0.6; cursor: not-allowed; }

  .input-group { margin-bottom: 16px; }
  .input-label { font-size: 13px; font-weight: 600; color: var(--text-secondary); margin-bottom: 6px; display: block; }
  .input { width: 100%; padding: 10px 14px; background: var(--bg-input); border: 1px solid var(--border); border-radius: var(--radius-sm); color: var(--text-primary); font-size: 14px; outline: none; font-family: 'Outfit', sans-serif; transition: border-color 0.2s; }
  .input:focus { border-color: var(--border-focus); }
  .input::placeholder { color: var(--text-muted); }
  select.input { appearance: none; cursor: pointer; }

  .search-bar { position: relative; margin-bottom: 20px; }
  .search-bar svg { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: var(--text-muted); }
  .search-bar .input { padding-left: 42px; }

  .collection-grid { display: grid; gap: 12px; }
  .collection-item { display: grid; grid-template-columns: 60px 1fr 100px 100px 100px 100px 120px 80px; align-items: center; gap: 12px; padding: 14px 18px; background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-md); transition: all 0.2s; cursor: pointer; animation: fadeIn 0.3s ease; }
  .collection-item:hover { border-color: rgba(59,139,245,0.3); background: var(--bg-card-hover); }
  .col-mobile { display: none; }
  .col-desktop { display: block; }
  .card-thumb { width: 50px; height: 70px; border-radius: 6px; object-fit: cover; background: var(--bg-elevated); border: 1px solid var(--border); }
  .card-thumb-placeholder { width: 50px; height: 70px; border-radius: 6px; background: var(--bg-elevated); border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; font-size: 10px; color: var(--text-muted); text-align: center; padding: 4px; }
  .card-info-name { font-weight: 600; font-size: 14px; }
  .card-info-meta { font-size: 12px; color: var(--text-secondary); margin-top: 2px; }
  .col-header { display: grid; grid-template-columns: 60px 1fr 100px 100px 100px 100px 120px 80px; gap: 12px; padding: 8px 18px; font-size: 11px; color: var(--text-muted); text-transform: uppercase; letter-spacing: 1px; font-weight: 600; }
  .gain-positive { color: var(--green); }
  .gain-negative { color: var(--red); }
  .mono { font-family: 'JetBrains Mono', monospace; font-size: 13px; }

  .filter-bar { display: flex; gap: 8px; margin-bottom: 20px; flex-wrap: wrap; align-items: center; }
  .filter-chip { padding: 6px 14px; border-radius: 20px; font-size: 13px; font-weight: 500; cursor: pointer; border: 1px solid var(--border); background: var(--bg-card); color: var(--text-secondary); transition: all 0.2s; }
  .filter-chip:hover { border-color: var(--highlight); color: var(--text-primary); }
  .filter-chip.active { background: var(--highlight); border-color: var(--highlight); color: #FFFFFF; }

  /* ── Price Tabs ── */
  .price-tabs { display: flex; gap: 4px; padding: 8px; background: var(--bg-elevated); border-radius: var(--radius-md) var(--radius-md) 0 0; }
  .price-tab { padding: 10px 20px; font-size: 13px; font-weight: 600; color: var(--text-muted); cursor: pointer; border: none; background: none; border-radius: var(--radius-sm); transition: all 0.2s; font-family: 'Outfit', sans-serif; display: flex; align-items: center; gap: 8px; }
  .price-tab:hover { color: var(--text-primary); background: rgba(255,255,255,0.05); }
  .price-tab.active { background: var(--highlight); color: #FFFFFF; }
  .price-tab img { height: 16px; width: auto; }
  .price-detail-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid rgba(28,61,107,0.4); }
  .price-detail-row:last-child { border-bottom: none; }
  .price-detail-label { font-size: 13px; color: var(--text-secondary); }
  .price-detail-value { font-size: 14px; font-weight: 700; font-family: 'JetBrains Mono', monospace; }
  .price-coming-soon { text-align: center; padding: 40px 20px; color: var(--text-muted); }
  .price-coming-soon h4 { font-size: 16px; font-weight: 700; margin-bottom: 8px; color: var(--text-secondary); }
  .price-coming-soon p { font-size: 13px; line-height: 1.6; }

  /* ── Set Browser ── */
  .set-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 10px; }
  .set-item { padding: 14px; cursor: pointer; display: flex; align-items: center; gap: 12px; background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-md); transition: all 0.2s; }
  .set-item:hover { border-color: var(--highlight); background: var(--bg-card-hover); }

  .catalog-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 14px; }
  .catalog-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-md); padding: 14px; cursor: pointer; transition: all 0.25s; animation: fadeIn 0.3s ease; }
  .catalog-card:hover { border-color: var(--accent); transform: translateY(-2px); box-shadow: var(--shadow-glow); }
  .catalog-card.selected { border-color: var(--accent); background: var(--accent-soft); }
  .catalog-card-img { width: 100%; aspect-ratio: 63/88; border-radius: 8px; object-fit: cover; background: var(--bg-elevated); margin-bottom: 10px; }
  .catalog-card-placeholder { width: 100%; aspect-ratio: 63/88; border-radius: 8px; background: var(--bg-elevated); display: flex; align-items: center; justify-content: center; flex-direction: column; margin-bottom: 10px; gap: 4px; border: 1px solid var(--border); }
  .catalog-card-placeholder .game-icon { font-size: 28px; }
  .catalog-card-placeholder .card-num { font-size: 11px; color: var(--text-muted); }
  .catalog-card-name { font-weight: 600; font-size: 14px; }
  .catalog-card-set { font-size: 12px; color: var(--text-secondary); margin-top: 2px; }
  .catalog-card-price { font-size: 13px; color: var(--accent); font-weight: 600; margin-top: 6px; font-family: 'JetBrains Mono', monospace; }

  .purchase-form { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 28px; max-width: 500px; animation: fadeIn 0.3s ease; }
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }

  .detail-header { display: flex; gap: 32px; margin-bottom: 32px; animation: fadeIn 0.4s ease; }
  .detail-image { width: 280px; min-width: 280px; border-radius: var(--radius-lg); overflow: hidden; border: 2px solid var(--border); box-shadow: 0 8px 40px rgba(0,0,0,0.4); }
  .detail-image img { width: 100%; display: block; }
  .detail-image-placeholder { width: 100%; aspect-ratio: 63/88; background: var(--bg-elevated); display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 8px; }
  .detail-info { flex: 1; }
  .detail-title { font-size: 32px; font-weight: 800; letter-spacing: -1px; }
  .detail-meta { display: flex; gap: 12px; margin-top: 8px; flex-wrap: wrap; }
  .detail-badge { padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; background: var(--bg-elevated); border: 1px solid var(--border); }
  .badge-pokemon { color: var(--pokemon-gold); border-color: rgba(255,215,0,0.3); background: rgba(255,215,0,0.08); }
  .badge-onepiece { color: var(--onepiece-red); border-color: rgba(220,38,38,0.3); background: rgba(220,38,38,0.08); }
  .detail-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-top: 24px; }

  .chart-container { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 24px; }
  .chart-title { font-size: 16px; font-weight: 700; margin-bottom: 16px; }

  .auth-container { display: flex; align-items: center; justify-content: center; min-height: 100vh; background: var(--bg-deep); padding: 24px; }
  .auth-box { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-xl); padding: 40px; width: 100%; max-width: 420px; animation: fadeIn 0.5s ease; }
  .auth-title { font-size: 28px; font-weight: 800; text-align: center; margin-bottom: 4px; }
  .auth-subtitle { font-size: 14px; color: var(--text-secondary); text-align: center; margin-bottom: 28px; }
  .auth-divider { display: flex; align-items: center; gap: 12px; margin: 20px 0; color: var(--text-muted); font-size: 13px; }
  .auth-divider::before, .auth-divider::after { content: ''; flex: 1; height: 1px; background: var(--border); }
  .auth-toggle { text-align: center; margin-top: 20px; font-size: 14px; color: var(--text-secondary); }
  .auth-toggle a { color: var(--highlight); cursor: pointer; font-weight: 600; }
  .auth-toggle a:hover { text-decoration: underline; }
  .auth-error { background: var(--red-soft); color: var(--red); padding: 10px 14px; border-radius: var(--radius-sm); font-size: 13px; margin-bottom: 16px; }

  .landing { min-height: 100vh; }
  .hero { text-align: center; padding: 100px 24px 60px; background: radial-gradient(ellipse at 50% 0%, rgba(219,0,0,0.08) 0%, rgba(59,139,245,0.06) 40%, transparent 70%); }
  .hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 6px 16px; border-radius: 20px; background: var(--highlight-soft); color: var(--highlight); font-size: 13px; font-weight: 600; margin-bottom: 24px; border: 1px solid rgba(219,0,0,0.25); }
  .hero h1 { font-size: 56px; font-weight: 900; letter-spacing: -2px; line-height: 1.1; max-width: 700px; margin: 0 auto 16px; }
  .hero h1 .gradient { background: linear-gradient(135deg, #DB0000, #FF4444, #FF7777); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .hero p { font-size: 18px; color: var(--text-secondary); max-width: 500px; margin: 0 auto 36px; line-height: 1.6; }
  .hero-actions { display: flex; gap: 12px; justify-content: center; }
  .features { padding: 80px 24px; max-width: 1000px; margin: 0 auto; }
  .features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
  .feature-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 28px; transition: all 0.3s; }
  .feature-card:hover { border-color: rgba(59,139,245,0.3); transform: translateY(-3px); }
  .feature-icon { width: 44px; height: 44px; border-radius: var(--radius-md); background: var(--accent-soft); display: flex; align-items: center; justify-content: center; margin-bottom: 16px; color: var(--accent); }
  .feature-title { font-size: 16px; font-weight: 700; margin-bottom: 8px; }
  .feature-desc { font-size: 14px; color: var(--text-secondary); line-height: 1.6; }

  .movers-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .mover-item { display: flex; align-items: center; gap: 12px; padding: 12px 14px; background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-md); transition: all 0.2s; }
  .mover-item:hover { border-color: rgba(59,139,245,0.2); }
  .mover-rank { font-size: 11px; color: var(--text-muted); font-weight: 700; min-width: 20px; }
  .mover-name { font-size: 13px; font-weight: 600; flex: 1; }
  .mover-change { font-size: 13px; font-weight: 600; font-family: 'JetBrains Mono', monospace; }

  .profit-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; margin-bottom: 24px; }
  .profit-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 20px; position: relative; overflow: hidden; transition: all 0.25s; }
  .profit-card:hover { border-color: rgba(59,139,245,0.25); }
  .profit-card .accent-bar { position: absolute; top: 0; left: 0; right: 0; height: 3px; }
  .profit-card .profit-icon { width: 36px; height: 36px; border-radius: var(--radius-sm); display: flex; align-items: center; justify-content: center; margin-bottom: 12px; font-size: 16px; }
  .profit-card .profit-label { font-size: 12px; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.8px; font-weight: 600; margin-bottom: 6px; }
  .profit-card .profit-value { font-size: 24px; font-weight: 800; letter-spacing: -0.5px; font-family: 'JetBrains Mono', monospace; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .profit-card .profit-sub { font-size: 12px; margin-top: 6px; font-weight: 500; display: flex; align-items: center; gap: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .top5-list { display: flex; flex-direction: column; gap: 8px; }
  .top5-item { display: flex; align-items: center; gap: 14px; padding: 12px 16px; background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-md); cursor: pointer; transition: all 0.2s; }
  .top5-item:hover { border-color: rgba(59,139,245,0.3); background: var(--bg-card-hover); }
  .top5-rank { font-size: 14px; font-weight: 800; color: var(--text-muted); min-width: 28px; font-family: 'JetBrains Mono', monospace; }
  .top5-rank.gold { color: #FFD700; }
  .top5-rank.silver { color: #C0C0C0; }
  .top5-rank.bronze { color: #CD7F32; }
  .top5-thumb { width: 44px; height: 62px; border-radius: 6px; object-fit: cover; background: var(--bg-elevated); border: 1px solid var(--border); flex-shrink: 0; }
  .top5-thumb-ph { width: 44px; height: 62px; border-radius: 6px; background: var(--bg-elevated); border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0; }
  .top5-info { flex: 1; min-width: 0; }
  .top5-name { font-size: 14px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .top5-meta { font-size: 12px; color: var(--text-secondary); margin-top: 2px; }
  .top5-value { text-align: right; flex-shrink: 0; }
  .top5-price { font-size: 15px; font-weight: 700; font-family: 'JetBrains Mono', monospace; }
  .top5-total { font-size: 11px; color: var(--text-muted); margin-top: 2px; }

  .dash-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 24px; }
  .dash-section { margin-bottom: 24px; }
  .dash-section-title { font-size: 16px; font-weight: 700; margin-bottom: 14px; display: flex; align-items: center; gap: 8px; }

  .toast { position: fixed; bottom: 24px; right: 24px; padding: 14px 20px; background: var(--bg-elevated); border: 1px solid var(--border); border-radius: var(--radius-md); font-size: 14px; font-weight: 500; animation: fadeIn 0.3s ease; z-index: 1000; box-shadow: 0 8px 30px rgba(0,0,0,0.4); }
  .toast-success { border-color: var(--green); }
  .toast-error { border-color: var(--red); }

  .empty-state { text-align: center; padding: 60px 24px; background: var(--bg-card); border: 1px solid var(--border); border-radius: var(--radius-lg); }
  .empty-state h3 { font-size: 20px; font-weight: 700; margin-bottom: 8px; }
  .empty-state p { color: var(--text-secondary); font-size: 14px; margin-bottom: 24px; }

  .loading-screen { display: flex; align-items: center; justify-content: center; min-height: 100vh; background: var(--bg-deep); flex-direction: column; gap: 16px; }
  .loading-screen svg { animation: spin 1s linear infinite; color: var(--accent); }
  .loading-screen p { color: var(--text-secondary); font-size: 14px; }

  /* ── Add Card Detail ── */
  .add-card-detail { display: flex; gap: 28px; flex-wrap: wrap; max-width: 100%; overflow: hidden; box-sizing: border-box; }
  .add-card-preview { width: 180px; flex-shrink: 0; }

  /* ── Purchase Modal ── */
  .purchase-modal-overlay {
    position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 300;
    background: rgba(0,0,0,0.6); backdrop-filter: blur(4px);
    display: flex; align-items: center; justify-content: center;
    padding: 20px; animation: fadeIn 0.2s ease;
  }
  .purchase-modal {
    background: var(--bg-card); border: 1px solid var(--border);
    border-radius: var(--radius-lg); width: 100%; max-width: 700px;
    max-height: 90vh; overflow-y: auto; animation: fadeIn 0.25s ease;
    box-shadow: 0 20px 60px rgba(0,0,0,0.4);
  }
  .purchase-modal-header {
    display: flex; justify-content: space-between; align-items: center;
    padding: 20px 24px; border-bottom: 1px solid var(--border);
    position: sticky; top: 0; background: var(--bg-card); z-index: 1;
  }
  .purchase-modal-body { padding: 24px; }

  /* ── Mobile Logo (hidden on desktop, shown on mobile) ── */
  .mobile-logo { display: none; }
  .mobile-topbar { display: none; }

  /* ── Mobile Bottom Navigation ── */
  .mobile-nav { display: none; }

  @media (max-width: 900px) {
    .sidebar { width: 64px; min-width: 64px; }
    .sidebar-brand { padding: 16px 12px; justify-content: center; font-size: 16px; }
    .sidebar-brand img { height: 32px !important; }
    .sidebar-link { padding: 10px; justify-content: center; font-size: 0; }
    .sidebar-section { display: none; }
    .sidebar-username, .sidebar-email { display: none; }
    .sidebar-footer { padding: 12px 8px; }
    .nav-logout { font-size: 0; padding: 8px; }
    .content { margin-left: 64px; padding: 24px 16px; }
    .collection-item { grid-template-columns: 50px 1fr 80px 80px 90px 70px; }
    .col-header { grid-template-columns: 50px 1fr 80px 80px 90px 70px; }
    .detail-header { flex-direction: column; }
    .detail-image { width: 100%; min-width: auto; max-width: 300px; }
    .features-grid { grid-template-columns: 1fr; }
    .movers-grid { grid-template-columns: 1fr; }
    .dash-row { grid-template-columns: 1fr; }
    .profit-grid { grid-template-columns: 1fr 1fr; }
    .hero h1 { font-size: 36px; }
  }

  @media (max-width: 640px) {
    /* Hide sidebar, show mobile nav */
    .sidebar { display: none; }
    .mobile-topbar {
      display: flex;
      position: fixed; top: 0; left: 0; right: 0; z-index: 200;
      background: rgba(8,22,46,0.97); backdrop-filter: blur(20px);
      border-bottom: 1px solid var(--border);
      padding: 10px 16px;
      align-items: center; justify-content: space-between;
    }
    .mobile-currency-select {
      padding: 6px 10px; font-size: 13px; font-family: 'Outfit', sans-serif;
      background: var(--bg-input); color: var(--text-primary);
      border: 1px solid var(--border); border-radius: var(--radius-sm);
      outline: none; cursor: pointer;
    }
    .mobile-nav {
      display: flex;
      position: fixed; bottom: 0; left: 0; right: 0; z-index: 200;
      background: rgba(8,22,46,0.97); backdrop-filter: blur(20px);
      border-top: 1px solid var(--border);
      padding: 6px 0 calc(6px + env(safe-area-inset-bottom));
      justify-content: space-around;
    }
    .mobile-nav-btn {
      display: flex; flex-direction: column; align-items: center; gap: 3px;
      padding: 6px 12px; border: none; background: none; cursor: pointer;
      color: var(--text-muted); font-size: 10px; font-family: 'Outfit', sans-serif;
      font-weight: 500; transition: color 0.2s;
    }
    .mobile-nav-btn svg { width: 22px; height: 22px; }
    .mobile-nav-btn.active { color: var(--highlight); }
    .mobile-nav-btn:hover { color: var(--text-primary); }

    /* Content adjustments */
    .content { margin-left: 0; padding: 60px 14px 80px; overflow-x: hidden; max-width: 100vw; box-sizing: border-box; }
    .card { overflow: hidden; max-width: 100%; box-sizing: border-box; }

    /* Page header */
    .page-title { font-size: 22px; }
    .page-subtitle { font-size: 13px; }

    /* Collection - mobile card layout */
    .col-desktop { display: none !important; }
    .col-mobile { display: block; }
    .collection-item { grid-template-columns: 1fr; padding: 0; gap: 0; overflow: hidden; }
    .col-header { display: none; }
    .col-mobile-top { display: flex; gap: 12px; padding: 14px 14px 10px; align-items: center; }
    .col-mobile-img { flex-shrink: 0; }
    .col-mobile-img img, .col-mobile-img .card-thumb { width: 56px; height: 78px; border-radius: 6px; object-fit: cover; }
    .col-mobile-img .card-thumb-placeholder { width: 56px; height: 78px; border-radius: 6px; display: flex; align-items: center; justify-content: center; background: var(--bg-elevated); font-size: 12px; }
    .col-mobile-info { flex: 1; min-width: 0; }
    .col-mobile-info .card-info-name { font-size: 14px; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .col-mobile-info .card-info-meta { font-size: 11px; }
    .col-mobile-prices { display: grid; grid-template-columns: 1fr 1fr; gap: 1px; background: var(--border); border-top: 1px solid var(--border); }
    .col-mobile-price-item { display: flex; justify-content: space-between; align-items: center; padding: 8px 14px; background: var(--bg-card); font-size: 13px; }
    .col-mobile-label { font-size: 11px; color: var(--text-muted); font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
    .col-mobile-actions { display: flex; gap: 8px; padding: 8px 14px; border-top: 1px solid var(--border); justify-content: flex-end; }
    .col-mobile-actions .btn { font-size: 12px; }

    /* Dashboard */
    .mobile-logo { display: block; }
    .profit-grid { grid-template-columns: 1fr 1fr; gap: 8px; }
    .profit-card { padding: 12px; min-width: 0; }
    .profit-card .profit-value { font-size: 16px; letter-spacing: -0.5px; }
    .profit-card .profit-label { font-size: 10px; margin-bottom: 4px; }
    .profit-card .profit-sub { font-size: 10px; margin-top: 4px; }
    .profit-card .profit-icon { width: 28px; height: 28px; margin-bottom: 8px; }
    .profit-card .profit-icon svg { width: 14px; height: 14px; }
    .dash-section-title { font-size: 15px; }
    .summary-grid { grid-template-columns: 1fr 1fr !important; }
    .card-value { font-size: 18px; }
    .card-label { font-size: 11px; }
    .summary-grid { grid-template-columns: 1fr 1fr !important; }

    /* Cards grid */
    .catalog-grid { grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 10px; }
    .catalog-card { padding: 10px; overflow: hidden; max-width: 100%; box-sizing: border-box; }
    .catalog-card-img { height: 160px; object-fit: contain; }
    .catalog-card-name { font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .catalog-card-set { font-size: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .catalog-card-price { font-size: 13px; }

    /* Add card detail - stack vertically on mobile */
    .add-card-detail { flex-direction: column; gap: 16px; }
    .add-card-preview { width: 100%; max-width: 200px; margin: 0 auto; }

    /* Purchase modal mobile */
    .purchase-modal-overlay { padding: 0; align-items: flex-end; }
    .purchase-modal { max-height: 95vh; border-radius: var(--radius-lg) var(--radius-lg) 0 0; max-width: 100%; }
    .purchase-modal-header { padding: 16px; }
    .purchase-modal-body { padding: 16px; }

    /* Set grid */
    .set-grid { grid-template-columns: 1fr; }

    /* Forms */
    .form-grid { grid-template-columns: 1fr; }
    .search-bar { margin-bottom: 12px; }

    /* Filter chips */
    .filter-bar { flex-wrap: wrap; gap: 6px; }
    .filter-chip { font-size: 12px; padding: 6px 12px; }

    /* Price tabs */
    .price-tabs { flex-wrap: wrap; padding: 6px; gap: 4px; }
    .price-tab { padding: 8px 12px; font-size: 12px; }
    .price-tab img { height: 14px !important; }
    .price-detail-row { padding: 8px 0; }
    .price-detail-label { font-size: 12px; }
    .price-detail-value { font-size: 13px; }

    /* Detail page */
    .detail-header { flex-direction: column; gap: 16px; }
    .detail-image { width: 100%; min-width: auto; max-width: 250px; margin: 0 auto; }
    .detail-title { font-size: 20px; }
    .detail-stats { grid-template-columns: 1fr 1fr; gap: 8px; }
    .detail-meta { flex-wrap: wrap; }

    /* Top 5 */
    .top5-item { padding: 10px; }

    /* Landing page */
    .hero { padding: 40px 20px; }
    .hero h1 { font-size: 28px; }
    .hero p { font-size: 14px; }
    .hero-actions { flex-direction: column; gap: 8px; }
    .hero-actions .btn { width: 100%; }
    .features-grid { grid-template-columns: 1fr; }

    /* Auth page */
    .auth-container { padding: 16px; }
    .auth-form { padding: 24px 16px; }

    /* Movers */
    .movers-grid { grid-template-columns: 1fr; }

    /* Selected card in add page */
    .purchase-form { min-width: 0; }
  }

  @media (max-width: 380px) {
    .catalog-grid { grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 8px; }
    .catalog-card-img { height: 140px; }
    .profit-card .profit-value { font-size: 14px; }
    .card-value { font-size: 16px; }
    .hero h1 { font-size: 24px; }
    .price-tabs { gap: 2px; }
    .price-tab { padding: 6px 8px; font-size: 11px; }
  }
`;
